import { withChartLayout } from 'components/common';
import ObstructiveSleepApnea from 'components/features/chart/special-charts/obstructive-sleep-apnea/ObstructiveSleepApnea';

const ObstructiveSleepApneaPage = withChartLayout('Obstructive Sleep Apnea')(ObstructiveSleepApnea);
export default ObstructiveSleepApneaPage;
